import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './MobileMenu.module.scss';

const MobileMenuItem = ({ children, spaced = false, className = '' }) => (
  <li className={classNames({ [styles['item--spaced']]: spaced }, className)}>
    {children}
  </li>
);

MobileMenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  spaced: PropTypes.bool,
  className: PropTypes.string
};

export default MobileMenuItem;
